import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const AuthVerify = (props) => {
  let location = useLocation();

  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");
    if (accessToken) {
      const decodedJwt = jwtDecode(accessToken.toString());
      if (decodedJwt.exp * 1000 -( 5 * 60 * 1000 )< Date.now()) {
        props.logOut();
      }
    }
  }, [location, props]);

  return;
};

export default AuthVerify;
